import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useGlobalStoreContext } from "@/context/globalStoreContext";

import usePlatform from "./usePlatform";
import { useProInfo } from "./useProInfo";

declare global {
  interface Window {
    freestar?: any;
  }
}

const ROLLOUT_ADS_RATE = 0.2;

function shouldRolloutAds(): boolean {
  const randomNumber = localStorage.getItem("freestarRandomNumber");

  if (!randomNumber) {
    const generated = Math.random();
    localStorage.setItem("freestarRandomNumber", generated.toString());
    return generated < ROLLOUT_ADS_RATE;
  }

  return Number(randomNumber) < ROLLOUT_ADS_RATE;
}

const adsFreePages = [
  // "/",
  "/password-reset",
  "/signin",
  "/signup",
  "/password",
  "/contact",
  "/pro",
];
const isAdsFreePage = (path: string) => adsFreePages.includes(path);

export function useFreestarAds() {
  const location = useLocation();

  const store = useGlobalStoreContext();

  const { isProFromCache } = useProInfo();

  const { isMobile } = usePlatform();

  useEffect(() => {
    return;
    const path = location.pathname;

    const isLogin = !!localStorage.getItem("jwtToken") || !!localStorage.getItem("isLogin");

    // if (!shouldRolloutAds()) {
    //   return;
    // }

    // 已经登录，但是还没有用户信息
    if (isLogin && !store.load) {
      return;
    }

    if (window.freestar && window.freestar.queue) {
      window.freestar.queue.push(function () {
        window.freestar.deleteAdSlots();
        try {
          window.freestar.deleteSidewall("awardtool-com_sidewall_left");
          window.freestar.deleteSidewall("awardtool-com_sidewall_right");
          window.freestar.deleteStickyFooter("awardtool-com_sticky_footer");
        } catch (error) {
          console.log("删除广告失败", error);
        }

        // 免广告页、付费用户
        if (isAdsFreePage(path) || isProFromCache) {
          console.log("设置禁用广告 + 清除已存在广告");
          window.freestar.trackPageview();
          return;
        }

        console.log("开启广告");

        if (!isMobile) {
          window.freestar.newSidewall("awardtool-com_sidewall_left");
          window.freestar.newSidewall("awardtool-com_sidewall_right");
        }

        window.freestar.newStickyFooter("awardtool-com_sticky_footer");

        window.freestar.trackPageview();
      });
    }
  }, [location.pathname, store, isProFromCache, isMobile]);
}

